/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AptosCoinDetailInfo = {
    CP: string;
    TSP: string;
    PRC: string;
    PRC24H: string;
    VOL24H: string;
    VOLC24H: string;
    MKC: string;
    FDV: string;
    HD: string;
    HD24H: string;
    TRS: string;
    DCM: string;
    NM: string;
    COINID: string;
    SB: string;
    ASTTP: string;
    PCT: AptosCoinDetailInfo.PCT;
    PST: AptosCoinDetailInfo.PST;
};

export namespace AptosCoinDetailInfo {

    export enum PCT {
        NATIVE = 'NATIVE',
        EMOJICOIN = 'EMOJICOIN',
        MEME = 'MEME',
        BRIDGED = 'BRIDGED',
        NONE = 'NONE',
    }

    export enum PST {
        VERIFIED = 'VERIFIED',
        RECOGNIZED = 'RECOGNIZED',
        UNVERIFIED = 'UNVERIFIED',
        BANNED = 'BANNED',
        INTERNAL_FA = 'INTERNAL_FA',
        LP = 'LP',
        NONE = 'NONE',
    }


}

